import { useEffect, useState } from "react";
import "../styles/HeroSlider.css";

import slide1 from "../assets/hero_4.jpg";
import slide2 from "../assets/hero.jpeg";

export default function HeroSlider() {
  const slides = [
    {
      image: slide1,
      title: "Your partner in Energy. Your Bridge to Opportunity",
    },
    {
      image: slide2,
      title: "Fueling Your Growth, Globally.",
    },
  ];

  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % slides.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [slides.length]);

  return (
    <section className="hero-slider">
      {slides.map((slide, index) => (
        <div
          key={index}
          className={`slide ${index === current ? "active" : ""}`}
          style={{ backgroundImage: `url(${slide.image})` }}
        >
          <div className="overlay"></div>
          <div className="content">
            <h1>{slide.title}</h1>
            <p>{slide.subtitle}</p>
          </div>
        </div>
      ))}
    </section>
  );
}
